
import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { cn } from '@/lib/utils';

function ConditionNode({ data }: { data: any }) {
  return (
    <div className={cn(
      "px-4 py-2 shadow-md rounded-md border-2 border-blue-500 bg-blue-50",
      "min-w-[180px] text-center rotate-45 transform-gpu"
    )}>
      <div className="font-bold -rotate-45 transform-gpu">{data.label}</div>
      <div className="text-xs text-muted-foreground -rotate-45 transform-gpu">
        {data.condition?.parameter || 'Set condition'}
      </div>
      
      <Handle 
        type="target" 
        position={Position.Top} 
        className="w-3 h-3 bg-blue-500 rotate-45 transform-gpu" 
      />
      <Handle 
        id="yes"
        type="source" 
        position={Position.Right} 
        className="w-3 h-3 bg-green-500"
      />
      <Handle 
        id="no"
        type="source" 
        position={Position.Bottom} 
        className="w-3 h-3 bg-red-500" 
      />
    </div>
  );
}

export default memo(ConditionNode);
